import { render } from "./RedirectQr.vue?vue&type=template&id=20b066ca"
import script from "./RedirectQr.vue?vue&type=script&lang=js"
export * from "./RedirectQr.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Cloud\\QrProductRedirect\\qr-product-redirect\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__